<template>
    <div class="margin-top-20">
        <div class="manage-title margin-bottom-20"><em class="txt">完成情况</em></div>
        <div class="table">
            <ul class="flex">
                <li class="item">
                    <h3 class="tit">预期点击量</h3>
                    <p class="num">{{statistics.task_clicks}}+</p>
                </li>
                <li class="item">
                    <h3 class="tit">完成点击量</h3>
                    <p class="num">{{statistics.real_click}}</p>
                </li>
                <li class="item">
                    <h3 class="tit">完成率</h3>
                    <p class="num">{{statistics.completion_rate}}%</p>
                </li>
                <li class="item">
                    <h3 class="tit">预付费用</h3>
                    <p class="num">{{statistics.task_price}}</p>
                </li>
                <li class="item">
                    <h3 class="tit">结算费用</h3>
                    <p class="num">{{statistics.settlement_free}}</p>
                </li>
                <li class="item">
                    <h3 class="tit">结余费用</h3>
                    <p class="num">{{statistics.balance_free}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ExtensionCompletion',
        props: {
            statistics: Object
        }
    }
</script>
<style scoped>
    .is-group{background: #eee;}
    .table{width:100%;}
    .table .item{width:16%;text-align: center;border-left:1px #eee solid;border-top: 1px #eee solid; border-bottom: 1px #eee solid;}
    .table .item:last-child{border-right:1px #eee solid;}
    .table .item .tit{height:46px;line-height:46px;background: #f5f5f5;}
    .table .item .num{height:46px;line-height:46px;}
</style>
